document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg && full) mainImg.src = full;
    });
  });
});
